import { Grid, SwipeableDrawer, LinearProgress } from "@material-ui/core";
import Button from "@material-ui/core/Button";
import { withStyles } from "@material-ui/core/styles";
import React from "react";
import { Query } from "react-apollo";
import GenericVariables from "../../../componentes/CRUD/genericVariables";
import Loading from "../../../componentes/Loading/Loading";
import PapperBlock from "../../../componentes/PapperBlock/PapperBlock";
import SnackMessage from "../../../componentes/SnakBar";
import { GetDashBoardDocument } from "../../../graphql/components";
import GraficoMediaTicketOperadora from "./componentes/graficoMediaTicketOperadora";
import GraficoTaxaMediaOperadora from "./componentes/graficoTaxaMediaOperadora";
import GraficoVendaDia from "./componentes/graficoVendaDia";
import GraficoVendaHora from "./componentes/graficoVendaHora";
import GraficoVendaOperadora from "./componentes/graficoVendaOperadora";
import GraficoVendaTipo from "./componentes/graficoVendaTipo";
import styles from "./dashboard-jss";
import "./estilo.css";
import FilterDashBoard from "./filterDashBoard";
import {
  copiaFiltroRadar,
  descricaoFiltroRadar,
  restauraFiltroRadar,
  variablesDashBoard,
  variablesDashBoardExibicao,
} from "./utilsDashBoard";
import * as Highcharts from "highcharts";
import "../DashboardNovo/componentes/highchartsPtBr";

// paleta da marca Conciliador para as series dos graficos
Highcharts.setOptions({
  colors: ["#0B5FD6", "#1B2A80", "#42A5F5", "#9FD4EA", "#5C6BC0", "#26C6DA", "#66BB6A", "#FFB74D", "#EF5350", "#8D6E63"],
});

interface Props {
  classes?: any;
  width?: any;
  mapVariablesFiltro?: any;
  variablesValorExibicao?: GenericVariables;
  variables: GenericVariables;
  isFiltering: boolean;
}

interface State {
  hasCodCliente: boolean;
  message: string;
  messageVariant: "success" | "warning" | "error" | "info";
  messageOpen: boolean;
  marginRight?: number;
  codpessoa?: number;
  codoperadora?: number;
  codexterno?: number;
  loading: boolean;
  filterOpened: boolean;
  data: Array<any>;
  seriesVendaOperadora: Array<any>;
  seriesVendaTipo: Array<any>;
  categoriaVendaDia: Array<any>;
  seriesVendaDia: Array<any>;
  categoriaVendaHora: Array<any>;
  seriesVendaHora: Array<any>;
  seriesTicketMedio: Array<any>;
  categoriaTaxaMedia: Array<any>;
  seriesTaxaMedia: Array<any>;
}

class DashBoardGrafico extends React.PureComponent<Props, State> {
  filtroAplicado = copiaFiltroRadar(variablesDashBoard, variablesDashBoardExibicao);

  constructor(props: Props) {
    super(props);
    this.state = {
      hasCodCliente: false,
      message: "",
      messageOpen: false,
      messageVariant: "success",
      loading: false,
      filterOpened: false,
      data: [],
      seriesVendaOperadora: [],
      seriesVendaTipo: [],
      categoriaVendaDia: [],
      seriesVendaDia: [],
      categoriaVendaHora: [],
      seriesVendaHora: [],
      seriesTicketMedio: [],
      categoriaTaxaMedia: [],
      seriesTaxaMedia: [],
    };
  }

  componentDidMount = () => {};

  closeMessage = () => this.setState({ messageOpen: false });

  openFilter = () => {
    this.filtroAplicado = copiaFiltroRadar(variablesDashBoard, variablesDashBoardExibicao);
    this.setState({ filterOpened: true });
  };

  // fechar sem filtrar descarta a edicao, senao a descricao e a proxima consulta usam valores nao aplicados
  toggleFilter = () => {
    restauraFiltroRadar(this.filtroAplicado, variablesDashBoard, variablesDashBoardExibicao);
    this.setState({ filterOpened: false });
  };

  pesquisando = (status: boolean) => {
    this.setState({ loading: status });
  };

  getDescricaoFiltro = () => descricaoFiltroRadar(variablesDashBoard, variablesDashBoardExibicao);

  search = async (refetchMethod: any) => {
    if (refetchMethod) {
      try {
        this.pesquisando(true);
        const response = await refetchMethod({ values: this.props.variables });
        this.setState({
          seriesVendaOperadora: response.data!.getDashBoard.seriesVendaOperadora,
          seriesVendaTipo: response.data!.getDashBoard.seriesVendaTipo,
          categoriaVendaDia: response.data!.getDashBoard.categoriaVendaDia,
          seriesVendaDia: response.data!.getDashBoard.seriesVendaDia,
          categoriaVendaHora: response.data!.getDashBoard.categoriaVendaHora,
          seriesVendaHora: response.data!.getDashBoard.seriesVendaHora,
          seriesTicketMedio: response.data!.getDashBoard.seriesTicketMedio,
          categoriaTaxaMedia: response.data!.getDashBoard.categoriaTaxaMedia,
          seriesTaxaMedia: response.data!.getDashBoard.seriesTaxaMedia,
        });
        this.setState({ filterOpened: false });
      } catch (e) {
        // O filtro continua aberto de proposito: sem aviso o usuario via os graficos
        // anteriores e concluia que o filtro nao tinha efeito.
        this.setState({
          message: "Não foi possível aplicar o filtro. Tente novamente.",
          messageVariant: "error",
          messageOpen: true,
        });
      } finally {
        this.pesquisando(false);
      }
    }
  };

  render() {
    const {
      message,
      messageVariant,
      messageOpen,
      filterOpened,
      seriesVendaOperadora,
      seriesVendaTipo,
      categoriaVendaDia,
      seriesVendaDia,
      categoriaVendaHora,
      seriesVendaHora,
      seriesTicketMedio,
      categoriaTaxaMedia,
      seriesTaxaMedia,
    } = this.state;

    return (
      <Query<any, any> variables={{ values: this.props.variables }} query={GetDashBoardDocument} errorPolicy="all">
        {({ data, loading, error, refetch }) => {
          if (loading) {
            return <Loading />;
          }

          return (
            <React.Fragment>
              <SwipeableDrawer anchor="top" open={filterOpened} onClose={this.toggleFilter} onOpen={this.toggleFilter}>
                <div style={{ minHeight: 250 }}>
                  <PapperBlock
                    title="Filtro"
                    icon="ios-search"
                    desc="Insira os filtros para efetuar uma pesquisa customizada"
                    whiteBg
                    stylesDesc={{ marginBottom: "20px" }}
                  >
                    <FilterDashBoard
                      variables={variablesDashBoard}
                      variablesValorExibicao={variablesDashBoardExibicao}
                      isFiltering={this.state.loading}
                    />

                    <div style={{ marginTop: 24, display: "flex", justifyContent: "flex-end" }}>
                      <Button
                        disabled={this.state.loading}
                        variant="outlined"
                        color="primary"
                        onClick={this.search.bind(this, refetch)}
                      >
                        Filtrar
                      </Button>
                      <Button
                        disabled={this.state.loading}
                        variant="outlined"
                        color="secondary"
                        onClick={this.toggleFilter}
                        style={{ marginLeft: 8 }}
                      >
                        Fechar
                      </Button>
                    </div>
                  </PapperBlock>
                </div>
                {this.state.loading && <LinearProgress color="secondary" style={{ height: 5.5 }} />}
              </SwipeableDrawer>

              <PapperBlock title="DashBoard" openFilter={this.openFilter} desc={this.getDescricaoFiltro()} plain>
                <div>
                  <Grid container spacing={2}>
                    <Grid item md={6} xs={12}>
                      <PapperBlock
                        title={`${variablesDashBoardExibicao.registro === "Pagamento" ? "Pagamento" : "Venda"} / Operadora`}
                        desc={`Gráfico ${
                          variablesDashBoardExibicao.registro === "Pagamento" ? "Pagamento" : "Venda"
                        } por Operadora`}
                      >
                        <GraficoVendaOperadora
                          series={
                            seriesVendaOperadora.length === 0 ? data!.getDashBoard.seriesVendaOperadora : seriesVendaOperadora
                          }
                        />
                      </PapperBlock>
                    </Grid>
                    <Grid item md={6} xs={12}>
                      <PapperBlock
                        title={`${variablesDashBoardExibicao.registro === "Pagamento" ? "Pagamento" : "Venda"} / Tipo`}
                        desc={`Gráfico ${variablesDashBoardExibicao.registro === "Pagamento" ? "Pagamento" : "venda"} por tipo`}
                      >
                        <GraficoVendaTipo
                          series={seriesVendaTipo.length === 0 ? data!.getDashBoard.seriesVendaTipo : seriesVendaTipo}
                        />
                      </PapperBlock>
                    </Grid>
                  </Grid>
                  <Grid container spacing={2}>
                    <Grid item md={12} xs={12}>
                      <PapperBlock
                        title={`${variablesDashBoardExibicao.registro === "Pagamento" ? "Pagamento" : "Venda"} / Dia`}
                        desc={`Gráfico ${variablesDashBoardExibicao.registro === "Pagamento" ? "Pagamento" : "venda"} por dia`}
                      >
                        <GraficoVendaDia
                          series={seriesVendaDia.length === 0 ? data!.getDashBoard.seriesVendaDia : seriesVendaDia}
                          categoria={categoriaVendaDia.length === 0 ? data!.getDashBoard.categoriaVendaDia : categoriaVendaDia}
                        />
                      </PapperBlock>
                    </Grid>
                  </Grid>

                  <Grid container spacing={2}>
                    <Grid item md={12} xs={12}>
                      <PapperBlock
                        title={`${variablesDashBoardExibicao.registro === "Pagamento" ? "Pagamento" : "Venda"} / Hora`}
                        desc={`Gráfico ${variablesDashBoardExibicao.registro === "Pagamento" ? "Pagamento" : "venda"} por hora`}
                      >
                        <GraficoVendaHora
                          series={seriesVendaHora.length === 0 ? data!.getDashBoard.seriesVendaHora : seriesVendaHora}
                          categoria={
                            categoriaVendaHora.length === 0 ? data!.getDashBoard.categoriaVendaHora : categoriaVendaHora
                          }
                        />
                      </PapperBlock>
                    </Grid>
                  </Grid>

                  <Grid container spacing={2}>
                    <Grid item md={6} xs={12}>
                      <PapperBlock title="Taxa Média por Operadora" desc="Gráfico taxa média por operadora">
                        <GraficoTaxaMediaOperadora
                          series={seriesTaxaMedia.length === 0 ? data!.getDashBoard.seriesTaxaMedia : seriesTaxaMedia}
                          categoria={
                            categoriaTaxaMedia.length === 0 ? data!.getDashBoard.categoriaTaxaMedia : categoriaTaxaMedia
                          }
                        />
                      </PapperBlock>
                    </Grid>
                    <Grid item md={6} xs={12}>
                      <PapperBlock title="Média de Ticket por Operadora" desc="Gráfico Média de Ticket por Operadora">
                        <GraficoMediaTicketOperadora
                          series={seriesTicketMedio.length === 0 ? data!.getDashBoard.seriesTicketMedio : seriesTicketMedio}
                        />
                      </PapperBlock>
                    </Grid>
                  </Grid>
                </div>
                <SnackMessage message={message} variant={messageVariant} open={messageOpen} close={this.closeMessage} />
              </PapperBlock>
            </React.Fragment>
          );
        }}
      </Query>
    );
  }
}

export default withStyles(styles as any)(DashBoardGrafico);
